const TrainersPage = () => (
  <div className="p-8 bg-white rounded-lg shadow-xl">
    <h2 className="text-3xl font-bold text-gray-800 mb-6">
      Meet Our Experienced Trainers
    </h2>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      <div className="bg-gray-50 p-6 rounded-lg shadow-md border border-gray-200 text-center">
        <img
          src="https://placehold.co/150x150/a78bfa/ffffff?text=Trainer+1"
          alt="Trainer Sarah"
          className="w-32 h-32 rounded-full mx-auto mb-4 object-cover border-4 border-purple-300"
        />
        <h3 className="text-2xl font-semibold text-purple-700 mb-2">
          Sarah Chen
        </h3>
        <p className="text-gray-600 mb-2">
          Hatha & Restorative Yoga Specialist
        </p>
        <p className="text-sm text-gray-500">
          Sarah has over 10 years of experience, focusing on mindful movement
          and deep relaxation.
        </p>
      </div>
      <div className="bg-gray-50 p-6 rounded-lg shadow-md border border-gray-200 text-center">
        <img
          src="https://placehold.co/150x150/818cf8/ffffff?text=Trainer+2"
          alt="Trainer David"
          className="w-32 h-32 rounded-full mx-auto mb-4 object-cover border-4 border-indigo-300"
        />
        <h3 className="text-2xl font-semibold text-indigo-700 mb-2">
          David Lee
        </h3>
        <p className="text-gray-600 mb-2">Vinyasa & Ashtanga Expert</p>
        <p className="text-sm text-gray-500">
          David brings high energy to his classes, challenging students to
          explore their full potential.
        </p>
      </div>
      <div className="bg-gray-50 p-6 rounded-lg shadow-md border border-gray-200 text-center">
        <img
          src="https://placehold.co/150x150/6ee7b7/ffffff?text=Trainer+3"
          alt="Trainer Emily"
          className="w-32 h-32 rounded-full mx-auto mb-4 object-cover border-4 border-green-300"
        />
        <h3 className="text-2xl font-semibold text-green-700 mb-2">
          Emily White
        </h3>
        <p className="text-gray-600 mb-2">Prenatal & Postnatal Yoga</p>
        <p className="text-sm text-gray-500">
          Emily provides a nurturing environment for mothers at every stage of
          their journey.
        </p>
      </div>
    </div>
  </div>
);

export default TrainersPage;
